import { createRoute } from "../../common/http";

import {
  GetFlightRequest,
  GetFlightResponse,
  GetFlightsRequest,
  GetFlightsResponse,
  IngestLogRequest,
  IngestLogResponse,
  RestoreLogRequest,
  RestoreLogResponse,
} from "./types";

const logbookEndpoints = {
  GET_FLIGHT: createRoute<GetFlightRequest, GetFlightResponse>("cloud_api_flights", "GET"),
  GET_FLIGHTS: createRoute<GetFlightsRequest, GetFlightsResponse>("cloud_api_flights", "GET"),
  INGEST_LOG: createRoute<IngestLogRequest, IngestLogResponse>("ingest_directory", "GET"),
  RESTORE_LOG: createRoute<RestoreLogRequest, RestoreLogResponse>("restore_directory", "GET"),
};

export default logbookEndpoints;
